/* ZCT_V22_SEITE (E2): kleine Helfer für alle Liquid-Seiten, Verhalten wie in v21.
   - Knöpfe mit data-zct-href (in v21 Knöpfe mit go()): Klick öffnet die Seite.
   - Wisch-Reihen .mobile-swipe-shell (JS-016, MobileSwipeScroller): Pfeile sichtbar, sobald gescrollt werden kann
     (links ab 24 px, rechts bis 8 px vor dem Ende), Schritt min(74 % der Breite, 520 px), weiches Scrollen;
     Prüfung bei scroll, resize, nach 500 ms und nach jedem Pfeil (sofort und nach 450 ms).
   - Merken-Herzen .wish[data-zct-merken] (ProductCard): Merkliste umschalten, Klasse on wie in v21.
   - Zurückgehen (JS-037, E3): offene SEO-Aufklapper (.zct-v19-intro, .zct-v19-seo, .zct-seo-resource) beim Klick auf einen Link in
     history.state merken (__zctDetails wie v21) und beim Zurückkommen wiederherstellen; die Scrollposition stellt der
     Browser selbst her (echte Seitenaufrufe). */
(function () {
  'use strict';
  // Bewegung komplett: Zeit-Token lesen; Shopify liefert das CSS verkleinert aus (200ms wird .2s), daher Sekunden und Millisekunden
  function zdZeit(v) { v = String(v || '').trim(); var x = parseFloat(v); if (isNaN(x)) return NaN; return /ms$/i.test(v) ? x : (/s$/i.test(v) ? x * 1000 : x); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zct-href]');
    if (!b || e.defaultPrevented) return;
    var ziel = b.getAttribute('data-zct-href');
    if (e.metaKey || e.ctrlKey) { window.open(ziel, '_blank'); return; }
    location.href = ziel;
  });

  function wischreihe(shell) {
    if (shell._zctWisch) return;
    var grid = shell.querySelector(':scope > div');
    var links = shell.querySelector(':scope > .mobile-swipe-left');
    var rechts = shell.querySelector(':scope > .mobile-swipe-right');
    if (!grid || !links || !rechts) return;
    shell._zctWisch = true;
    function setze(btn, an, basis) {
      var k = basis + ' ' + (an ? 'visible' : '');
      if (btn.className !== k) btn.className = k;
      btn.setAttribute('aria-disabled', String(!an));
    }
    function pruefen() {
      var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
      setze(links, grid.scrollLeft > 24, 'mobile-swipe-btn mobile-swipe-left');
      setze(rechts, grid.scrollLeft < max - 8, 'mobile-swipe-btn mobile-swipe-right');
    }
    function bewegen(richtung) {
      var schritt = Math.min(grid.clientWidth * 0.74, 520);
      var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
      var ziel = Math.max(0, Math.min(max, grid.scrollLeft + richtung * schritt));
      grid.scrollTo({ left: ziel, behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      requestAnimationFrame(pruefen);
      setTimeout(pruefen, 450);
    }
    links.addEventListener('click', function () { bewegen(-1); });
    rechts.addEventListener('click', function () { bewegen(1); });
    grid.addEventListener('scroll', pruefen, { passive: true });
    window.addEventListener('resize', pruefen);
    pruefen();
    setTimeout(pruefen, 500);
  }

  function herzen() {
    var liste = (window.zctLaden && window.zctLaden.wish()) || [];
    document.querySelectorAll('.wish[data-zct-merken]').forEach(function (b) {
      var k = 'wish ' + (liste.indexOf(b.getAttribute('data-zct-merken')) >= 0 ? 'on' : '');
      if (b.className !== k) b.className = k;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.wish[data-zct-merken]');
    if (!b || !window.zctLaden) return;
    e.preventDefault(); e.stopPropagation();
    window.zctLaden.toggleWish(b.getAttribute('data-zct-merken'));
    // Plan 013: Herz bestätigt das Merken mit einem kurzen Puls
    if (window.zctPuls && (window.zctLaden.wish() || []).indexOf(b.getAttribute('data-zct-merken')) >= 0) window.zctPuls(b.querySelector('svg') || b);
  });
  window.addEventListener('zct:laden', herzen);

  // v21 merkt nur die v19-Aufklapper und verliert sie, wenn go() den Verlaufseintrag überschreibt; hier alle SEO-Aufklapper,
  // damit „Zurück“ immer den Stand von vorher zeigt (wie in v21 bei Seitenwechseln ohne Neuladen)
  var AUFKLAPPER = '.zct-v19-intro details,.zct-v19-seo details,.zct-seo-resource details';
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('a[href]')) return;
    try {
      var offen = Array.prototype.map.call(document.querySelectorAll(AUFKLAPPER), function (d) { return d.open; });
      history.replaceState(Object.assign({}, history.state, { __zctDetails: offen }), '', location.href);
    } catch (err) {}
  }, true);
  function aufklapperZurueck() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      var gemerkt = nav && nav.type === 'back_forward' && history.state && history.state.__zctDetails;
      if (!gemerkt) return;
      document.querySelectorAll(AUFKLAPPER).forEach(function (d, i) { d.open = !!gemerkt[i]; });
    } catch (err) {}
  }

  function start() {
    aufklapperZurueck();
    document.querySelectorAll('.mobile-swipe-shell').forEach(wischreihe);
    herzen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);

  // FAQ (E6) wie in v21: eine Antwort offen, Zeichen + / −. Die Antworten stehen von Anfang an zugeklappt (hidden) im
  // Seiteninhalt (Tim T029: Antworttext im Server-HTML, nur eingeklappt) und werden hier nur auf- und zugeklappt.
  class ZctFaq extends HTMLElement {
    connectedCallback() {
      if (this._zct) return; this._zct = true;
      var items = Array.prototype.slice.call(this.querySelectorAll('.legal-faq-item')), offen = {}; // Plan 006: unabhängig, mehrere offen
      // Paket D (Bewegung): Höhe und Deckkraft 200 ms kräftiges ease-out wie die übrigen Aufklapper; beim Schließen erst nach
      // der Animation verbergen. „Bewegung reduzieren“: sofort.
      function klappen(a, auf) {
        var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Start: ganz zu (hidden) = von 0, sonst der aktuelle Stand (auch mitten in einer Animation); Ziel: natürliche Höhe bzw. 0
        var neu = a.hidden;
        if (auf) { a.hidden = false; a.removeAttribute('data-zct-zu'); } else a.setAttribute('data-zct-zu', '');
        if (ruhig || !a.animate) { if (!auf) a.hidden = true; return; }
        var cs = getComputedStyle(a);
        var von = neu ? 0 : a.getBoundingClientRect().height, opVon = neu ? 0 : parseFloat(cs.opacity), pbVon = neu ? '0px' : cs.paddingBottom;
        a.getAnimations().forEach(function (x) { x.cancel(); });
        var voll = a.getBoundingClientRect().height, pb = getComputedStyle(a).paddingBottom;
        a.style.overflow = 'hidden';
        // Bewegung komplett (Plan 006): Dauer und Kurve aus den Tokens (Öffnen 200 ms, Schließen 160 ms) wie alle Aufklapper
        var rs = getComputedStyle(document.documentElement), ms = zdZeit(rs.getPropertyValue(auf ? '--zd-dauer-aufklapper' : '--zd-dauer-aufklapper-zu'));
        var anim = a.animate([{ height: von + 'px', paddingBottom: pbVon, opacity: opVon }, { height: (auf ? voll : 0) + 'px', paddingBottom: auf ? pb : '0px', opacity: auf ? 1 : 0 }],
          { duration: isNaN(ms) ? (auf ? 200 : 160) : ms, easing: (rs.getPropertyValue('--zd-kurve-aus') || '').trim() || 'cubic-bezier(0.23, 1, 0.32, 1)' });
        anim.onfinish = function () { a.style.overflow = ''; if (!auf) a.hidden = true; };
      }
      function zeichnen() {
        items.forEach(function (it, i) {
          var c = 'legal-faq-item ' + (!!offen[i] ? 'open' : ''); if (it.className !== c) it.className = c;
          // Plan 006: Symbol aus zwei Strichen (CSS, dreht sofort über data-zd-ziel) statt Textzeichen; Zustand für Bildschirmleser
          it.setAttribute('data-zd-ziel', !!offen[i] ? 'auf' : 'zu');
          var ic = it.querySelector('.legal-faq-icon'); if (ic && ic.textContent) { ic.textContent = ''; ic.setAttribute('aria-hidden', 'true'); }
          var q = it.querySelector('.legal-faq-q'); if (q) q.setAttribute('aria-expanded', String(!!offen[i]));
          var a = it.querySelector('.legal-faq-a'); if (!a) return;
          var istOffen = !a.hasAttribute('data-zct-zu');
          if (!!offen[i] && !istOffen) klappen(a, true);
          else if (!offen[i] && istOffen) klappen(a, false);
        });
      }
      items.forEach(function (it, i) { var q = it.querySelector('.legal-faq-q'); if (q) q.addEventListener('click', function () { offen[i] = !offen[i]; zeichnen(); }); });
      items.forEach(function (it) { var q = it.querySelector('.legal-faq-q'); if (q && !q.hasAttribute('aria-expanded')) q.setAttribute('aria-expanded', 'false'); });
    }
  }
  if (!customElements.get('zct-faq')) customElements.define('zct-faq', ZctFaq);
})();
